export const PERMISSIONS = {
    "TRANSPORTADORA": {
        "AGENDAMENTO_ATTACH": "transportadora.agendamento.attach",
        "AGENDAMENTO_DELETE": "transportadora.agendamento.delete",
        "AGENDAMENTO_LIST": "transportadora.agendamento.list",
        "AGENDAMENTO_UPDATE_WEIGHT": "transportadora.agendamento.update_weight",
        "AGENDAMENTO_VIEW": "transportadora.agendamento.view",
        "AVALIACAO_ANSWER": "transportadora.avaliacao.answer",
        "AVALIACAO_LIST": "transportadora.avaliacao.list",
        "AVALIACAO_VIEW": "transportadora.avaliacao.view",
        "BILLING_APPROVE": "transportadora.billing.approve",
        "BILLING_LIST": "transportadora.billing.list",
        "CAMINHONEIRO_CREATE": "transportadora.caminhoneiro.create",
        "CAMINHONEIRO_DELETE": "transportadora.caminhoneiro.delete",
        "CAMINHONEIRO_LIST": "transportadora.caminhoneiro.list",
        "CAMINHONEIRO_UPDATE": "transportadora.caminhoneiro.update",
        "CAMINHONEIRO_VIEW": "transportadora.caminhoneiro.view",
        "DASHBOARD_VIEW": "transportadora.dashboard.view",
        "DOCUMENTO_FISCAL_AGENDAMENTO_CREATE": "transportadora.documento_fiscal_agendamento.create",
        "DOCUMENTO_FISCAL_AGENDAMENTO_LIST": "transportadora.documento_fiscal_agendamento.list",
        "EMPRESA_GROUP_CREATE": "transportadora.empresa_group.create",
        "EMPRESA_GROUP_DELETE": "transportadora.empresa_group.delete",
        "EMPRESA_GROUP_LIST": "transportadora.empresa_group.list",
        "EMPRESA_GROUP_UPDATE": "transportadora.empresa_group.update",
        "EMPRESA_GROUP_VIEW": "transportadora.empresa_group.view",
        "EMPRESA_UPDATE": "transportadora.empresa.update",
        "EMPRESA_VIEW": "transportadora.empresa.view",
        "GEOLOCALIZACAO_CAMINHONEIRO_VIEW": "transportadora.geolocalizacao_caminhoneiro.view",
        "LEILAO_BID": "transportadora.leilao.bid",
        "LEILAO_LIST": "transportadora.leilao.list",
        "LEILAO_VIEW": "transportadora.leilao.view",
        "LOTE_ATTACH": "transportadora.lote.attach",
        "LOTE_CALL_DRIVERS": "transportadora.lote.call_drivers",
        "LOTE_CANCEL": "transportadora.lote.cancel",
        "LOTE_CREATE": "transportadora.lote.create",
        "LOTE_EXPORT_PDF": "transportadora.lote.export_pdf",
        "LOTE_FINISH": "transportadora.lote.finish",
        "LOTE_LIST": "transportadora.lote.list",
        "LOTE_UPDATE": "transportadora.lote.update",
        "LOTE_VIEW": "transportadora.lote.view",
        "MATRIZ_FILIAL_LIST": "transportadora.matriz_filial.list",
        "MATRIZ_FILIAL_VIEW": "transportadora.matriz_filial.view",
        "OFERTA_ACCEPT": "transportadora.oferta.accept",
        "OFERTA_CREATE": "transportadora.oferta.create",
        "OFERTA_LIST": "transportadora.oferta.list",
        "OFERTA_REFUSE": "transportadora.oferta.refuse",
        "OFERTA_VIEW": "transportadora.oferta.view",
        "ORCAMENTO_LIST": "transportadora.orcamento.list",
        "ORCAMENTO_SEND": "transportadora.orcamento.send",
        "ORCAMENTO_VIEW": "transportadora.orcamento.view",
        "PERFIL_UPDATE": "transportadora.perfil.update",
        "PERFIL_VIEW": "transportadora.perfil.view",
        "PROGRAMACAO_ACCEPT": "transportadora.programacao.accept",
        "PROGRAMACAO_CANCEL": "transportadora.programacao.cancel",
        "PROGRAMACAO_CREATE": "transportadora.programacao.create",
        "PROGRAMACAO_DELETE": "transportadora.programacao.delete",
        "PROGRAMACAO_FINISH": "transportadora.programacao.finish",
        "PROGRAMACAO_LIST": "transportadora.programacao.list",
        "PROGRAMACAO_REFUSE": "transportadora.programacao.refuse",
        "PROGRAMACAO_UPDATE": "transportadora.programacao.update",
        "PROGRAMACAO_VIEW": "transportadora.programacao.view",
        "PROPRIETARIO_ANTT_CREATE": "transportadora.proprietario_antt.create",
        "PROPRIETARIO_ANTT_DELETE": "transportadora.proprietario_antt.delete",
        "PROPRIETARIO_ANTT_LIST": "transportadora.proprietario_antt.list",
        "PROPRIETARIO_ANTT_UPDATE": "transportadora.proprietario_antt.update",
        "PROPRIETARIO_ANTT_VIEW": "transportadora.proprietario_antt.view",
        "RELATORIO_EXPORT": "transportadora.relatorio.export",
        "RELATORIO_LIST": "transportadora.relatorio.list",
        "TRANSPORTADOR_CREATE": "transportadora.transportador.create",
        "TRANSPORTADOR_DELETE": "transportadora.transportador.delete",
        "TRANSPORTADOR_LIST": "transportadora.transportador.list",
        "TRANSPORTADOR_UPDATE": "transportadora.transportador.update",
        "TRANSPORTADOR_VIEW": "transportadora.transportador.view",
        "UNIDADE_CARGA_CREATE": "transportadora.unidade_carga.create",
        "UNIDADE_CARGA_DELETE": "transportadora.unidade_carga.delete",
        "UNIDADE_CARGA_LIST": "transportadora.unidade_carga.list",
        "UNIDADE_CARGA_UPDATE": "transportadora.unidade_carga.update",
        "UNIDADE_CARGA_VIEW": "transportadora.unidade_carga.view",
        "UNIDADE_TRACAO_CREATE": "transportadora.unidade_tracao.create",
        "UNIDADE_TRACAO_DELETE": "transportadora.unidade_tracao.delete",
        "UNIDADE_TRACAO_LIST": "transportadora.unidade_tracao.list",
        "UNIDADE_TRACAO_UPDATE": "transportadora.unidade_tracao.update",
        "UNIDADE_TRACAO_VIEW": "transportadora.unidade_tracao.view",
        "USUARIO_CREATE": "transportadora.usuario.create",
        "USUARIO_DELETE": "transportadora.usuario.delete",
        "USUARIO_LIST": "transportadora.usuario.list",
        "USUARIO_UPDATE": "transportadora.usuario.update",
        "USUARIO_VIEW": "transportadora.usuario.view"
    },
    "EMBARCADORA": {
        "AGENDAMENTO_ATTACH": "embarcadora.agendamento.attach",
        "AGENDAMENTO_DELETE": "embarcadora.agendamento.delete",
        "AGENDAMENTO_FINISH": "embarcadora.agendamento.finish",
        "AGENDAMENTO_LIST": "embarcadora.agendamento.list",
        "AGENDAMENTO_LOAD": "embarcadora.agendamento.load",
        "AGENDAMENTO_UNLOAD": "embarcadora.agendamento.unload",
        "AGENDAMENTO_UPDATE_WEIGHT": "embarcadora.agendamento.update_weight",
        "AGENDAMENTO_VIEW": "embarcadora.agendamento.view",
        "ARMAZEM_CONFIGURACAO_AGENDAMENTO_MANAGE_CLIENTS": "embarcadora.armazem_configuracao_agendamento.manage_clients",
        "ARMAZEM_CONFIGURACAO_AGENDAMENTO_UPDATE": "embarcadora.armazem_configuracao_agendamento.update",
        "ARMAZEM_CONFIGURACAO_AGENDAMENTO_VIEW": "embarcadora.armazem_configuracao_agendamento.view",
        "ARMAZEM_TURNO_CLIENTE_LIST": "embarcadora.armazem_turno_cliente.list",
        "ARMAZEM_TURNO_CLIENTE_UPDATE": "embarcadora.armazem_turno_cliente.update",
        "ARMAZEM_TURNO_CLIENTE_VIEW": "embarcadora.armazem_turno_cliente.view",
        "ARMAZEM_TURNO_CREATE": "embarcadora.armazem_turno.create",
        "ARMAZEM_TURNO_DELETE": "embarcadora.armazem_turno.delete",
        "ARMAZEM_TURNO_LIST": "embarcadora.armazem_turno.list",
        "ARMAZEM_TURNO_MANAGE_CLIENTS": "embarcadora.armazem_turno.manage_clients",
        "ARMAZEM_TURNO_UPDATE": "embarcadora.armazem_turno.update",
        "ARMAZEM_TURNO_VIEW": "embarcadora.armazem_turno.view",
        "CAMINHONEIRO_LIST": "embarcadora.caminhoneiro.list",
        "CAMINHONEIRO_UPDATE": "embarcadora.caminhoneiro.update",
        "CAMINHONEIRO_VIEW": "embarcadora.caminhoneiro.view",
        "DASHBOARD_VIEW": "embarcadora.dashboard.view",
        "DOCUMENTO_FISCAL_AGENDAMENTO_CREATE": "embarcadora.documento_fiscal_agendamento.create",
        "DOCUMENTO_FISCAL_AGENDAMENTO_DELETE": "embarcadora.documento_fiscal_agendamento.delete",
        "DOCUMENTO_FISCAL_AGENDAMENTO_LIST": "embarcadora.documento_fiscal_agendamento.list",
        "EMPRESA_GROUP_CREATE": "embarcadora.empresa_group.create",
        "EMPRESA_GROUP_DELETE": "embarcadora.empresa_group.delete",
        "EMPRESA_GROUP_LIST": "embarcadora.empresa_group.list",
        "EMPRESA_GROUP_UPDATE": "embarcadora.empresa_group.update",
        "EMPRESA_GROUP_VIEW": "embarcadora.empresa_group.view",
        "EMPRESA_PRODUTO_CREATE": "embarcadora.empresa_produto.create",
        "EMPRESA_PRODUTO_LIST": "embarcadora.empresa_produto.list",
        "EMPRESA_PRODUTO_UPDATE": "embarcadora.empresa_produto.update",
        "EMPRESA_PRODUTO_VIEW": "embarcadora.empresa_produto.view",
        "EMPRESA_UPDATE": "embarcadora.empresa.update",
        "EMPRESA_UPDATE_LOCATION": "embarcadora.empresa.update_location",
        "EMPRESA_VIEW": "embarcadora.empresa.view",
        "FAVORITO_EMBARCADORA_CREATE": "embarcadora.favorito_embarcadora.create",
        "FAVORITO_EMBARCADORA_DELETE": "embarcadora.favorito_embarcadora.delete",
        "FAVORITO_EMBARCADORA_LIST": "embarcadora.favorito_embarcadora.list",
        "FAVORITO_EMBARCADORA_UPDATE": "embarcadora.favorito_embarcadora.update",
        "FAVORITO_EMBARCADORA_VIEW": "embarcadora.favorito_embarcadora.view",
        "GEOLOCALIZACAO_CAMINHONEIRO_VIEW": "embarcadora.geolocalizacao_caminhoneiro.view",
        "LOCAL_CREATE": "embarcadora.local.create",
        "LOCAL_DELETE": "embarcadora.local.delete",
        "LOCAL_LIST": "embarcadora.local.list",
        "LOCAL_UPDATE": "embarcadora.local.update",
        "LOCAL_VIEW": "embarcadora.local.view",
        "LOTE_ATTACH": "embarcadora.lote.attach",
        "LOTE_CALL_DRIVERS": "embarcadora.lote.call_drivers",
        "LOTE_CANCEL": "embarcadora.lote.cancel",
        "LOTE_CREATE": "embarcadora.lote.create",
        "LOTE_FINISH": "embarcadora.lote.finish",
        "LOTE_LIST": "embarcadora.lote.list",
        "LOTE_SUSPEND_OPERATION": "embarcadora.lote.suspend_operation",
        "LOTE_UPDATE": "embarcadora.lote.update",
        "LOTE_VIEW": "embarcadora.lote.view",
        "MATRIZ_FILIAL_LIST": "embarcadora.matriz_filial.list",
        "MATRIZ_FILIAL_VIEW": "embarcadora.matriz_filial.view",
        "OFERTA_LIST": "embarcadora.oferta.list",
        "PERFIL_UPDATE": "embarcadora.perfil.update",
        "PERFIL_VIEW": "embarcadora.perfil.view",
        "PRODUTO_ACONDICIONAMENTO_CREATE": "embarcadora.produto_acondicionamento.create",
        "PRODUTO_ACONDICIONAMENTO_LIST": "embarcadora.produto_acondicionamento.list",
        "PRODUTO_ACONDICIONAMENTO_UPDATE": "embarcadora.produto_acondicionamento.update",
        "PRODUTO_ACONDICIONAMENTO_VIEW": "embarcadora.produto_acondicionamento.view",
        "PROGRAMACAO_ACCEPT": "embarcadora.programacao.accept",
        "PROGRAMACAO_BLOCK_MOVEMENT": "embarcadora.programacao.block_movement",
        "PROGRAMACAO_CANCEL": "embarcadora.programacao.cancel",
        "PROGRAMACAO_CREATE": "embarcadora.programacao.create",
        "PROGRAMACAO_DELETE": "embarcadora.programacao.delete",
        "PROGRAMACAO_FINISH": "embarcadora.programacao.finish",
        "PROGRAMACAO_LIST": "embarcadora.programacao.list",
        "PROGRAMACAO_REFUSE": "embarcadora.programacao.refuse",
        "PROGRAMACAO_SHARED_POOL": "embarcadora.programacao.shared_pool",
        "PROGRAMACAO_SUSPEND_OPERATION": "embarcadora.programacao.suspend_operation",
        "PROGRAMACAO_UPDATE": "embarcadora.programacao.update",
        "PROGRAMACAO_VIEW": "embarcadora.programacao.view",
        "RELATORIO_EXPORT": "embarcadora.relatorio.export",
        "RELATORIO_LIST": "embarcadora.relatorio.list",
        "TRANSPORTADOR_LIST": "embarcadora.transportador.list",
        "USUARIO_CREATE": "embarcadora.usuario.create",
        "USUARIO_DELETE": "embarcadora.usuario.delete",
        "USUARIO_LIST": "embarcadora.usuario.list",
        "USUARIO_UPDATE": "embarcadora.usuario.update",
        "USUARIO_VIEW": "embarcadora.usuario.view"
    },
    "USINA": {
        "EMPRESA_GROUP_CREATE": "usina.empresa_group.create",
        "EMPRESA_GROUP_DELETE": "usina.empresa_group.delete",
        "EMPRESA_GROUP_LIST": "usina.empresa_group.list",
        "EMPRESA_GROUP_UPDATE": "usina.empresa_group.update",
        "EMPRESA_GROUP_VIEW": "usina.empresa_group.view",
        "EMPRESA_UPDATE": "usina.empresa.update",
        "EMPRESA_VIEW": "usina.empresa.view",
        "PERFIL_UPDATE": "usina.perfil.update",
        "PERFIL_VIEW": "usina.perfil.view",
        "USINA_CHEGADA_CREATE": "usina.usina_chegada.create",
        "USINA_CHEGADA_DELETE": "usina.usina_chegada.delete",
        "USINA_CHEGADA_EXPORT": "usina.usina_chegada.export",
        "USINA_CHEGADA_LIST": "usina.usina_chegada.list",
        "USINA_CHEGADA_UPDATE": "usina.usina_chegada.update",
        "USINA_CHEGADA_VIEW": "usina.usina_chegada.view",
        "USINA_MOTORISTA_CREATE": "usina.usina_motorista.create",
        "USINA_MOTORISTA_LIST": "usina.usina_motorista.list",
        "USINA_MOTORISTA_UPDATE": "usina.usina_motorista.update",
        "USINA_MOTORISTA_VIEW": "usina.usina_motorista.view",
        "USINA_PERIODO_CREATE": "usina.usina_periodo.create",
        "USINA_PERIODO_DELETE": "usina.usina_periodo.delete",
        "USINA_PERIODO_LIST": "usina.usina_periodo.list",
        "USINA_PERIODO_UPDATE": "usina.usina_periodo.update",
        "USINA_PERIODO_VIEW": "usina.usina_periodo.view",
        "USINA_TRANSPORTADORA_CREATE": "usina.usina_transportadora.create",
        "USINA_TRANSPORTADORA_DELETE": "usina.usina_transportadora.delete",
        "USINA_TRANSPORTADORA_UPDATE": "usina.usina_transportadora.update",
        "USUARIO_CREATE": "usina.usuario.create",
        "USUARIO_DELETE": "usina.usuario.delete",
        "USUARIO_LIST": "usina.usuario.list",
        "USUARIO_UPDATE": "usina.usuario.update",
        "USUARIO_VIEW": "usina.usuario.view"
    }
};
